import React, { useState, useMemo } from "react";

/* build f(x) from string */
// eslint-disable-next-line no-new-func
const build = expr => new Function("x", `with(Math){return ${expr};}`);

export default function TangentSlopeTool({ expr = "x**3", xmin = -3, xmax = 3 }) {
  const f = useMemo(()=>build(expr), [expr]);
  const [x0, setX0] = useState(1);

  /* numeric derivative */
  const h = 1e-4;
  const slope = (f(x0+h)-f(x0-h))/(2*h);

  /* simple SVG scale */
  const w=320, hSvg=180, px = x=>((x-xmin)/(xmax-xmin))*w,
        py = y=>hSvg/2 - y*30;           // 1 unit ≈30px

  /* sample curve */
  const pts = Array.from({length:101},(_,i)=>{
    const x = xmin + (i/100)*(xmax-xmin);
    return `${px(x)},${py(f(x))}`;
  }).join(" ");

  /* tangent line endpoints */
  const tl1 = {x:xmin, y: f(x0)+slope*(xmin-x0)},
        tl2 = {x:xmax, y: f(x0)+slope*(xmax-x0)};

  return (
    <div style={{ border:"1px solid #ccc", padding:10, maxWidth:360 }}>
      <strong>Tangent-Line Explorer &nbsp;</strong>
      <span style={{ fontSize:24 }}>(f(x) = {expr})</span><br/>
      x<sub>0</sub>&nbsp;
      <input type="range" min={xmin} max={xmax} step={0.1}
             value={x0} onChange={e=>setX0(+e.target.value)}
             style={{ width:260 }} /> {x0.toFixed(1)}
      <svg width={w} height={hSvg} style={{ background:"#fafafa", marginTop:6 }}>
        <polyline points={pts} fill="none" stroke="#2196f3" strokeWidth="2"/>
        <line x1={px(tl1.x)} y1={py(tl1.y)} x2={px(tl2.x)} y2={py(tl2.y)}
              stroke="orange" strokeWidth="2" strokeDasharray="4 2"/>
        <circle cx={px(x0)} cy={py(f(x0))} r={4} fill="crimson"/>
      </svg>
      <p style={{ fontSize:24, margin:0 }}>
        Slope at x<sub>0</sub>= {x0.toFixed(1)} is&nbsp;≈ {slope.toFixed(3)}
      </p>
    </div>
  );
}
